@if (locationNames?.length) {
  <div layout layout-align-items-center>
    <rt-icon name="place" margin-right-small-xxx></rt-icon>
    @if (locationNames.length === 1) {
      <span>
        {{ locationNames[0] }}
      </span>
    } @else {
      <span [rtTooltip]="locationNames.join(', ')" [rtTooltipPosition]="'below'">
        {{ locationNames.length }}
        {{ 'rtr.common.plurals.location' | translate: { count: locationNames.length } }}
      </span>
    }
  </div>
}
